import MedialistView from "./List/List";
import Forms from "../../../app/Components/Forms/Forms";

const Medialist = {

    init() {

        this.el = $('[component].Medialist');

        if (!this.el.length) {
            return;
        }

        this.form = this.el.find("form[name='MedialistEditor']");
        this.submitButton = this.el.find('button[type="submit"]');
        this.resetButton = this.el.find('button[type="reset"]');

        this.start();
        this.bind();
    },

    start() {
        MedialistView.init(this.el, this.form);

        Forms.init(this.form);
        Forms.focusFirstInput(this.form);
        //Forms.setButtonPulseAfterEdit();
        Forms.setFormSubmitButton(this.submitButton);
        Forms.setResetButton($(this.resetButton));
    },

    bind() {
        this.form.change((event) => {
            const form = Forms.inputData2(Medialist.form);

            if (form.get("id") > 0) {
                Medialist.submitButton.data("text", Medialist.submitButton.text()).text("Uložiť");
                Medialist.form.addClass("editing");
            } else {
                Medialist.submitButton.text(Medialist.submitButton.data("text")).removeClass("highlight pulse");
                Medialist.form.removeClass("editing");
            }
        });

        this.form.submit((event) => {
            Forms.setSendData( Forms.inputData(Medialist.form) );
        });

        this.resetButton.click((event) => {
            setTimeout(() => {
                Medialist.form.trigger("change");
            }, 100);
        });
    }
}
export default Medialist;